import { EntityWrapper } from "./EntityWrapper";
export class LazyLoadedProxyHandler implements ProxyHandler<EntityWrapper>
{
    constructor() { }

    get(target: EntityWrapper, property: PropertyKey, _receiver: unknown): unknown
    {
        if (property === "SetLazyLoadParent" || property === "replaceTarget")
        {
            const origMethod = target[property];
            return function (...args)
            {
                const result = origMethod.apply(target, args);
                return result;
            };
        }
        else if (property === "toJSON")
        {
            if (target.wasCreated && Object.keys(target.target).filter(f => !f.startsWith("$")).length === 0)
                return function proxyIsEmptyToJSON(..._args: Array<unknown>)
                {
                    return null;
                };
            return function proxyToJSON(..._args: Array<unknown>)
            {
                return target.target;
            };
        }
        else if (property === "toString")
        {
            return function proxyToString(..._args: Array<unknown>)
            {
                return `[ProxyModel "${target.target.$$TypeName}"]`;
            };
        }
        else if (property === "$isEntityWrapper") return true;
        else if (property === "$value") return target.target;
        else if (property === "$modCount") return target.$modCount;
        return target.target[property];
    }

    getOwnPropertyDescriptor(target: EntityWrapper, p: PropertyKey): PropertyDescriptor
    {
        return Object.getOwnPropertyDescriptor(target.target, p);
    }

    getPrototypeOf(target: EntityWrapper): object
    {
        return Reflect.getPrototypeOf(target.target);
    }

    has(target: EntityWrapper, property: PropertyKey): boolean
    {
        if (property === "$isEntityWrapper"
            || property === "$value"
            || property === "$modCount")
        {
            return true;
        }

        return Reflect.has(target.target, property);
    }

    isExtensible(target: EntityWrapper): boolean
    {
        return Reflect.isExtensible(target.target);
    }

    ownKeys(target: EntityWrapper): Array<string | symbol>
    {
        return Reflect.ownKeys(target.target);
    }

    set(target: EntityWrapper, property: PropertyKey, value: any): boolean
    {
        let selectedProperty = "Selected";
        if (target.target["$$SelectProperty"])
        {
            selectedProperty = target.target["$$SelectProperty"];
        }
        if (property !== selectedProperty && value !== Reflect.get(target.target, property) && !property.toString().startsWith("$") && (value === null || value === undefined || !value["$isEntityWrapper"]))
        {
            target.$modCount++;
            const rowState = target.target["SerializedRowState"];
            if (rowState === "Unchanged")
                target.target["SerializedRowState"] = "Modified";
            else if (rowState === undefined && target.target["$$Parent"] && target.target["$$Parent"]["SerializedRowState"] === "Unchanged")
                target.target["$$Parent"]["SerializedRowState"] = "Modified";
        }
        const ret = Reflect.set(target.target, property, value);
        target.maybeReload(property.toString());
        return ret;
    }

    apply(target: any, thisArg: any, argArray?: any): any
    {
        return Reflect.apply(target, thisArg, argArray);
    }

    setPrototypeOf(target: EntityWrapper, v: any): boolean
    {
        return target.target.setPrototypeOf(v);
    }

    preventExtensions(target: EntityWrapper): boolean
    {
        return Object.preventExtensions(target.target);
    }

    deleteProperty(target: EntityWrapper, p: PropertyKey): boolean
    {
        return Reflect.deleteProperty(target.target, p);
    }

    defineProperty(target: EntityWrapper, p: PropertyKey, attributes: PropertyDescriptor): boolean
    {
        return Reflect.defineProperty(target.target, p, attributes);
    }

    construct(target: EntityWrapper, argArray: any, newTarget?: any): any
    {
        return Reflect.construct(target.target, argArray, newTarget);
    }
}
